export const SET_ACTIVE_USER = "SET_ACTIVE_USER";
export const SET_ACTIVE_GROUP = "SET_ACTIVE_GROUP";
export const SET_CONTACT_USERS = "SET_CONTACT_USERS";
export const SET_USER_GROUPS = "SET__USER_GROUPS";
export const SET_GROUP_MEM_INFO = "SET__GROUP_MEM_INFO";
export const SET_IS_TYPING = "SET_IS_TYPING";
export const SET_NEW_GROUP_MESSAGE = "SET_NEW_GROUP_MESSAGE";
export const SET_TOTAL_CONTACTS = "SET_TOTAL_CONTACTS";
export const SET_ALL_GROUPS = "SET_ALL_GROUPS";
export const SET_MAKE_CALL = "SET_MAKE_CALL";
export const SET_ON_CALL_COMING = "SET_ON_CALL_COMING";
export const SET_CALL_ACCEPTED = "SET_CALL_ACCEPTED";
export const SET_DATA_TO_CALL = "SET_DATA_TO_CALL";
export const SET_HEADER_DATA = "SET_HEADER_DATA";
export const SET_ONLINE_USERS = "SER_ONLINE_USERS";
export const SET_CONTACT_USER_META = "SET_CONTACT_USER_META";
export const SET_USER_GROUP_META = "SET_USER_GROUP_META";
